import { render, staticRenderFns } from "./LaboratoryQuestion.vue?vue&type=template&id=24fa6022&scoped=true&"
import script from "./LaboratoryQuestion.vue?vue&type=script&lang=js&"
export * from "./LaboratoryQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryQuestion.vue?vue&type=style&index=0&id=24fa6022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa6022",
  null
  
)

export default component.exports